module.exports = __webpack_public_path__ + "static/media/logo.e3af6784.svg";